var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      staticStyle: { width: "96vw", margin: "10px !important" },
      attrs: { scrollable: "" },
      model: {
        value: _vm.dialogNote,
        callback: function($$v) {
          _vm.dialogNote = $$v
        },
        expression: "dialogNote"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              staticStyle: { background: "#2562af !important" },
              attrs: { card: "" }
            },
            [
              _c("v-toolbar-title", { staticClass: "white--text CSChatThai" }, [
                _vm._v("  โน๊ต")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.checkUser == "owner"
                ? _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.edit_note($event)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("fas fa-edit")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkUser == "owner"
                ? _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.remove_note($event)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("far fa-trash-alt")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkUser == "editstate"
                ? _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.save_note($event)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("far fa-save")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkUser != "editstate"
                ? _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.closeDialog($event)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("clear")]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { dark: "", icon: "", flat: "" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.cancel_note($event)
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            color: "white !important",
                            "font-size": "20px !important"
                          }
                        },
                        [_vm._v("clear")]
                      )
                    ],
                    1
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _vm.checkUser != "undefined" && _vm.checkUser != "editstate"
            ? _c(
                "v-card-text",
                {
                  staticStyle: { height: "550px", padding: "10px !important" }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                padding: "15px 0px",
                                display: "flex",
                                "justify-content": "center"
                              },
                              attrs: {
                                xs2: "",
                                xl2: "",
                                lg2: "",
                                md2: "",
                                sm2: ""
                              }
                            },
                            [
                              _c(
                                "v-avatar",
                                {
                                  staticClass: "profileBG",
                                  attrs: { size: "35" }
                                },
                                [
                                  _vm.note_detail.user_created.profile_picture
                                    ? _c("img", {
                                        staticClass: "alligator-turtle",
                                        attrs: {
                                          src:
                                            _vm.backend +
                                            _vm.note_detail.user_created
                                              .profile_picture
                                        }
                                      })
                                    : _c("span", { staticClass: "headline" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.note_detail.user_created.display_name.charAt(
                                              0
                                            )
                                          )
                                        )
                                      ])
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                padding: "10px 10px 2px  0px",
                                "text-align": "left"
                              },
                              attrs: {
                                xs10: "",
                                xl10: "",
                                lg10: "",
                                md10: "",
                                sm10: ""
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#2562af !important",
                                    "font-weight": "600",
                                    "white-space": "nowrap",
                                    width: "15em",
                                    overflow: "hidden",
                                    "text-overflow": "ellipsis"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.note_detail.user_created.display_name
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticStyle: {
                                  width: "90%",
                                  "white-space": "break-spaces",
                                  overflow: "hidden"
                                },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm
                                      .convert(_vm.note_detail.note_data.text)
                                      .replace(/(?:\r\n|\r|\n)/g, "<br>")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "font-size": "9px",
                                    color: "#1010106b",
                                    "margin-top": "10px",
                                    "margin-bottom": "0 !important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "สร้างเมื่อ " +
                                      _vm._s(
                                        _vm.dateMoment(
                                          _vm.note_detail.create_at
                                        )
                                      ) +
                                      " - " +
                                      _vm._s(
                                        _vm.timeMoment(
                                          _vm.note_detail.create_at
                                        )
                                      )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.note_detail.last_update
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "font-size": "9px",
                                        color: "#1010106b",
                                        "margin-bottom": "0 !important"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "แก้ไขล่าสุดเมื่อ " +
                                          _vm._s(
                                            _vm.dateMoment(
                                              _vm.note_detail.last_update
                                            )
                                          ) +
                                          " - " +
                                          _vm._s(
                                            _vm.timeMoment(
                                              _vm.note_detail.last_update
                                            )
                                          )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                xl12: "",
                                lg12: "",
                                md12: "",
                                sm12: ""
                              }
                            },
                            [_c("v-divider")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm.checkUser == "editstate"
            ? _c(
                "v-card-text",
                {
                  staticStyle: { height: "550px", padding: "10px !important" }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { row: "", wrap: "" }
                    },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticStyle: {
                                padding: "10px 10px 2px  0px",
                                "text-align": "left"
                              },
                              attrs: {
                                xs12: "",
                                xl12: "",
                                lg12: "",
                                md12: "",
                                sm12: ""
                              }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  outlined: "",
                                  name: "input-7-4",
                                  rows: "23",
                                  placeholder: "แชร์โน๊ตในห้องสนทนา",
                                  value:
                                    "The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                                },
                                model: {
                                  value: _vm.note_data,
                                  callback: function($$v) {
                                    _vm.note_data = $$v
                                  },
                                  expression: "note_data"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                xl12: "",
                                lg12: "",
                                md12: "",
                                sm12: ""
                              }
                            },
                            [_c("v-divider")],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "v-card-text",
                {
                  staticStyle: {
                    height: "550px",
                    padding: "10px !important",
                    "text-align": "center"
                  }
                },
                [_vm._v("\n       ไม่พบโน๊ตที่คุณเปิด\n     ")]
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49868810", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49868810","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mail/Detail/NoteDialog.vue
// module id = null
// module chunks = 